interface Provider {
  id: number;
  name?: string;
  string_id?: string;
  lowerCaseName?: string;
  games_count?: number;
}

interface FilterParams {
  [key: string]: string | number | boolean | null | undefined | Provider;

  brandId?: number;
  provider: Provider | null;
  tagId?: number;
  isRecommendation?: boolean;
  isFavorite?: boolean;
}

const LS_KEY = "filterParams";

class FilterService {
  private filterParams: FilterParams = {} as FilterParams;

  constructor() {
    this.loadFilterParams();
  }

  public get getFilterParams(): FilterParams {
    return {
      brandId: this.filterParams.brandId,
      provider: this.filterParams.provider,
      tagId: this.filterParams.tagId,
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public setParam(key: keyof FilterParams, value: any) {
    this.filterParams[key] = value;
    this.saveFilterParams();
  }

  private saveFilterParams() {
    const paramsToSave: FilterParams = {} as FilterParams;
    Object.keys(this.filterParams).forEach((key) => {
      if (this.filterParams[key] !== undefined) {
        paramsToSave[key] = this.filterParams[key];
      }
    });

    const queryString = JSON.stringify(paramsToSave);
    localStorage.setItem(LS_KEY, queryString);
  }

  removeFilters() {
    localStorage.removeItem(LS_KEY);
  }

  private loadFilterParams() {
    const queryString = localStorage.getItem(LS_KEY);

    if (queryString) {
      this.filterParams = JSON.parse(queryString);
    }
  }
}

export const filterService = new FilterService();
